import './CountryPage.css';

export const TopCities = ({ country }) => {
    return (
        <div className="main-content">
            <section className="cities-section">
                <h2>Top Cities Preferred by Students in { country.name }</h2>
                <p>{ country.topCities.title }</p>
                <div className="cities-grid">
                    { country.topCities.cities.map((city, index) => (
                        <div key={index} className="city-item">
                            <h4>{ city.name }</h4>
                            <p>{ city.description }</p>
                        </div>
                    ))}
                    
                </div>
            </section>
        </div>
    )
}